import { render, staticRenderFns } from "./VolunteerContact.vue?vue&type=template&id=84632bb0&"
import script from "./VolunteerContact.vue?vue&type=script&lang=js&"
export * from "./VolunteerContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports